import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import FormatPrice from '@shared/containers/FormatPrice';

import PriceDiscount from './components/PriceDiscount';
import PriceLineThrough from './components/PriceLineThrough';

const FormatPriceContainer = styled.span`
  ${props =>
    props.boldText &&
    css`
      ${({ theme }) => theme.fontFamily.secondaryFont.mediumBold};
    `};
`;

function CartItemPrice({
  subtotal,
  subtotalNoDiscount,
  available,
  subsidizedProduct,
}) {
  const hasDiscount = useMemo(
    () => subtotal !== null && subtotal < subtotalNoDiscount,
    [subtotal, subtotalNoDiscount],
  );

  if (!available) return null;

  return hasDiscount || subsidizedProduct ? (
    <>
      <PriceDiscount>
        <FormatPrice value={subtotal} />
      </PriceDiscount>
      {!!hasDiscount && (
        <PriceLineThrough>
          <FormatPrice value={subtotalNoDiscount} />
        </PriceLineThrough>
      )}
    </>
  ) : (
    <FormatPriceContainer>
      <FormatPrice value={subtotalNoDiscount} />
    </FormatPriceContainer>
  );
}

CartItemPrice.propTypes = {
  subtotal: PropTypes.number.isRequired,
  subtotalNoDiscount: PropTypes.number.isRequired,
  available: PropTypes.bool.isRequired,
  subsidizedProduct: PropTypes.bool.isRequired,
};

export default React.memo(CartItemPrice);
